import {RecordForm} from '../forms/RecordForm';
import {useInvoice} from '../hooks/useInvoice';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {Invoice} from "../types.ts";

export const AddPage = () => {
    const { createRecord } = useInvoice();

    return (
        <FormPageLayout
            title='Add Invoice'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as Invoice} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};